/** Earliest product rate year available in filters and year pickers. */
export const PRODUCT_RATE_START_YEAR = 2020;

/** How many years beyond the current year to include (N + 2 => offset 2). */
export const PRODUCT_RATE_MAX_YEAR_OFFSET = 2;

export function getProductRateMaxYear(referenceDate = new Date()) {
  return referenceDate.getFullYear() + PRODUCT_RATE_MAX_YEAR_OFFSET;
}

export function getProductRateYearCount(referenceDate = new Date()) {
  return getProductRateMaxYear(referenceDate) - PRODUCT_RATE_START_YEAR + 1;
}

/** Descending list of year strings, e.g. ["2028", "2027", ... "2020"]. */
export function getProductRateYearList(referenceDate = new Date()) {
  const maxYear = getProductRateMaxYear(referenceDate);
  const years = [];
  for (let year = maxYear; year >= PRODUCT_RATE_START_YEAR; year--) {
    years.push(`${year}`);
  }
  return years;
}

/** Year options for a-select / v-autocomplete ({ label, value }). */
export function getProductRateYearOptions(referenceDate = new Date()) {
  return getProductRateYearList(referenceDate).map((year) => ({
    label: year,
    value: year,
  }));
}
